import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormText,
  Row,
  Col,
  Container,
  Label,
  FormGroup
} from "reactstrap";
import AddIcon from "react-icons/lib/md/library-add";
import { alertConstants, appConstants } from "../../_constants";
import { connect } from "react-redux";
import { alertActions, commonActions, modalActions } from "../../_actions";
import { apiActions } from "../../_actions/api.actions";
import { apiService, commonService } from "../../_services";
import FileUpload from "react-dropzone";
import FileIcon from "react-icons/lib/md/cloud-upload";
import SelectListComponent from "../utils/selectList";
import PaymentFileTemplate from "./PaymentFileTemplate.xlsx";
import NotificationSystem from "react-notification-system";
import { store } from "../../_helpers";

const fileUploadStyle = {
  width: "100%",
  paddingTop: "20px",
  paddingBottom: "20px",
  border: "1px dashed #aaa",
  borderRadius: "10px",
  cursor: "pointer"
};

const months = [
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 }
];

class PaymentHeaderContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      monthOptions: months,
      selectedMonth: "",
      file: null,
      fileName: null,
      modal: false,
      modalClass: "",
      errorHeader: false, //Error state mutable via Redux
      successHeader: false, //Success message mutable via Redux
      componentErrorMessages: [], //Errors generated within the component form
      componentError: false, //Errors generated within the component
      isVGGUser: false,
      // alert messages
      notification: {
        // title: 'Default Title',
        message: "Default Message",
        level: "success",
        position: "tr",
        dismissible: true
      },
      uploadPaymentEntityTypeId: null
    };
    this._notificationSystem = null;
    this._lastNotificationAdded = null;
  }

  componentDidMount() {
    const reduxState = store.getState();
    let { authentication, entities } = reduxState;
    const { dispatch } = this.props;
    
    if (authentication.user !== undefined) {
      const { user } = authentication;
      if (
        user.AviRole === appConstants.ROLES.VGG_SUPERADMIN ||
        user.AviRole === appConstants.ROLES.VGG_USER
      ) {
        this.setState({ isVGGUser: true });
      } else {
        this.setState({ isVGGUser: false });
      }
    }
    /* for maker checker. However this is not used yet due to the endpoint is expecting a file and payload view template is expecting a string */
    if (!entities) {
      dispatch(commonActions.getEntities());
    } else {
      this.setEntityTypes(entities);
    }
  }

  componentWillReceiveProps = function(nextProps) {
    const { alert } = nextProps;
    const { modal, entities } = nextProps;
    if (alert) {
      if (alert.type === alertConstants.SUCCESS) {
        // this.setState({error: false, success: alert.message})
        this.setState({
          errorHeader: false,
          successHeader: "Operation successful"
        });
        this.resetForm();
      } else if (alert.type === alertConstants.CLEAR) {
        this.setState({ successHeader: false, errorHeader: false });
      } else {
        this.setState({ successHeader: false, errorHeader: alert.message });
      }
    }
    if (modal) {
      if (modal.type === appConstants.OPEN_MODAL) {
        this.setState({
          modal: true,
          modalClass: modal.modalClass
        });
      } else if (modal.type === appConstants.CLOSE_MODAL) {
        this.setState({
          modal: false,
          modalClass: modal.modalClass
        });
        this.resetForm();
      }
    }
    /* for maker checker. Howevevver this is not used yet due to the endpoint is expecting a file and payload view template is expecting a string */
    if (entities) {
      this.setEntityTypes(entities);
    }
  };

  /* set entity types for maker checker. However this method is not used yet due to the endpoint is expecting a file and payload view template is expecting a string */
  setEntityTypes = entities => {
    let uploadPaymentEntityTypeId;

    entities.forEach(entity => {
      if (entity.EntityType === appConstants.APP_ENTITIES.UPLOAD_PAYMENT) {
        uploadPaymentEntityTypeId = entity.EntityTypeId;
      }
    });
    this.setState({ uploadPaymentEntityTypeId });
  };

  resetForm() {
    this.setState({
      componentError: false,
      componentErrorMessages: [],
      file: null,
      fileName: ""
    });
    this.resetError();
  }

  resetError() {
    this.props.dispatch(modalActions.clear());
    this.props.dispatch(alertActions.clear());
  }

  toggle = (e, modalClass) => {
    if (this.state.modal) {
      this.resetForm();
      this.props.dispatch(modalActions.close({ modalClass: modalClass }));
    } else {
      this.props.dispatch(modalActions.open({ modalClass: modalClass }));
    }
  };
  renderPageResponse() {
    const { errorHeader } = this.state;

    if (errorHeader && typeof errorHeader !== "string") {
      return (
        <div className="alert alert-danger" style={{ paddingLeft: 0 }}>
          <ul>
            {errorHeader.map((item, i) => (
              <li key={i}> {item} </li>
            ))}
          </ul>
        </div>
      );
    } else if (this.state.componentError) {
      return (
        <div className="alert alert-danger">{this.state.componentError}</div>
      );
    } else if (this.state.successHeader) {
      return <div className="alert alert-success">{this.state.success}</div>;
    }
  }
  handleFormSubmit = event => {
    event.preventDefault();
    const { dispatch } = this.props;
    this.setState({ contentError: false });

    this.setState({ alertMessage: {} });

    dispatch(apiActions.startRequest());

    let data = new FormData();
    data.append("file", this.state.file);
    data.append("Month", this.state.selectedMonth.value);

    // let url_ = appConstants.PAS_URL + '/api/payment/processfileasmultipartcontent';

    commonService
      .uploadPayment(data)
      .then(response => {
        if (response.status === appConstants.SUCCESS_RESPONSE) {
          if (response.response === "") {
            this.toggle(null, "modalSlide");
            this.props.notify(
              "Payment file uploaded successfully",
              appConstants.NOTIFY_SUCCESS
            );
            dispatch(apiActions.endRequest());
          } else {
            let err_msg = response.response.split("<br>");
            err_msg.unshift(
              "The file has been successfully processed but the following document types have been found and ignored:"
            );
            dispatch(alertActions.error(err_msg));
            dispatch(apiActions.endRequest());
          }
        } else if (response.status === appConstants.ERROR_RESPONSE) {
          const err_msg = response.response.split("<br>");
          dispatch(alertActions.error(err_msg));
          dispatch(apiActions.endRequest());
        }
        this.setState({ selectedMonth: "", file: null, fileName: null });
      })
      .catch(error => {
        let errorMessage = apiService.interpretErrorResponse(error);
        dispatch(alertActions.error([errorMessage]));
        dispatch(apiActions.endRequest());
        this.setState({ selectedMonth: "", file: null, fileName: null });
      });
  };

  onChange = event => {
    this.setState({ file: event.target.files[0] });
  };

  onDrop = files => {
    this.setState({ fileName: files[0].name, file: files[0] });
  };
  render() {
    let modalResponse = this.renderPageResponse();
    const { requesting, pageRequesting } = this.props;
    const {
      monthOptions,
      file,
      fileName,
      selectedMonth,
      isVGGUser
    } = this.state;
    return (
      <div className="view-header d-flex align-items-center">
        <header className="text-white">
          <h1 className="h5 title text-uppercase"> Payment Reconciliation</h1>
          <p className="mb-0 subtitle text-nowrap">
            {" "}
            All Payment Reconciliations
          </p>
        </header>
        {!isVGGUser && (
          <div className="ml-auto d-flex mt-2">
            <div className="hidden-sm-down">
              <Button
                className="btn-avi-secondary"
                disabled={pageRequesting || requesting}
                onClick={e => this.toggle(e, "modalSlideIn")}
              >
                <AddIcon color="#ffffff" size="20" /> Upload Payment
              </Button>
            </div>
          </div>
        )}
        <Modal
          size={"md"}
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.state.modalClass}
        >
          <ModalHeader toggle={this.toggle}>Payment Upload</ModalHeader>
          <Form onSubmit={this.handleFormSubmit}>
            <ModalBody>
              {modalResponse}
              <Container>
                <Row>
                  <Col sm="12">
                    <FormGroup className="mb-4">
                      <Label>Month</Label>
                      <SelectListComponent
                        placeholder={"Select month..."}
                        data={monthOptions}
                        valueKey="value"
                        textField="label"
                        selectValue={selectedMonth}
                        onValueChange={payload =>
                          this.setState({ selectedMonth: payload })
                        }
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <FileUpload onDrop={this.onDrop} style={fileUploadStyle}>
                      <div className="text-center">
                        <FileIcon size="40" color="#43a8df" />
                        {!fileName && (
                          <div>
                            <h5>Drag & drop payment file here</h5>
                            <p>or click to upload</p>
                            <FormText className="muted">
                              Only .xlsx files are accepted for upload.
                            </FormText>
                          </div>
                        )}
                        {fileName && (
                          <div>
                            <p>{fileName}</p>
                          </div>
                        )}
                      </div>
                    </FileUpload>
                  </Col>
                </Row>
              </Container>
            </ModalBody>
            <ModalFooter>
              <small>
                <a href={PaymentFileTemplate} download>
                  Download Template
                </a>
              </small>
              <Button
                className="btn-avi-primary"
                disabled={requesting || !selectedMonth || !file}
              >
                {" "}
                Proceed{" "}
              </Button>{" "}
              <Button color="secondary" onClick={this.toggle}>
                Cancel
              </Button>
            </ModalFooter>
            <NotificationSystem ref="notificationSystem" />
          </Form>

          {requesting && <div className={"loading-dot active"} />}
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { loggingIn } = state.authentication;
  const { pageRequesting, requesting } = state.api;
  const { modal, alert } = state;
  return {
    loggingIn,
    requesting,
    pageRequesting,
    modal,
    alert
  };
}
export default connect(mapStateToProps)(PaymentHeaderContent);



// WEBPACK FOOTER //
// ./src/views/payment-reconciliation/view-header.js